import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function ShowReservationField(props) {
  const { currentVariant } = useContext(ConfiguratorContext)

  const showReservationsField = currentVariant.show_reservations_field ?? '0'

  if (showReservationsField !== '1') {
    return null
  }

  return <>{props.children}</>
}
